import DeviceManagement from "./device-management.page";

export default DeviceManagement;
